import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Typography from "@mui/material/Typography";
import { MouseEvent, useCallback } from "react";

import { Identifier, useNotify } from "react-admin";

import { Maybe } from "types";

import * as S from "./Cell.styled";

interface CellProps {
  value: Maybe<Identifier>;
  copiable?: boolean;
}
export const Cell = ({ value, copiable }: CellProps) => {
  const notify = useNotify();

  const copyToClipboard = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      if (value) {
        navigator.clipboard.writeText(value.toString());

        notify("Copied to clipboard");
      }
    },
    [notify, value]
  );

  return (
    <S.CellContainer>
      <Typography
        variant="body2"
        sx={{
          lineHeight: 2.5,
          mr: 2
        }}
      >
        {value}
      </Typography>
      {copiable && value && (
        <S.CellIconContainer onClick={copyToClipboard} size="small">
          <ContentCopyIcon color="action" fontSize="small" />
        </S.CellIconContainer>
      )}
    </S.CellContainer>
  );
};
